import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { CupsService } from '../../../../../services/cups.service';
import { HttpClient } from '@angular/common/http';


interface CustomerResponse {
  response: {
    customer_name: string;
    address: string;
    city: string;
    state: string;
    zip_code: string;
    customer_region: number;
    distributor_id: bigint;
  };
}
interface RowData {
    businessunit_name: string;
    customer_distributer_Id: bigint;
    customer_id: bigint;
    customer_name: string;
    distributor_id: bigint;
    distributor_name: string;
}

@Component({
  selector: 'app-manage-customers-grid',
  templateUrl: './manage-customers-grid.component.html',
  styleUrls: ['./manage-customers-grid.component.css']
})
export class ManageCustomersGridComponent implements OnInit {
  sortedCols: any;
  manageCustomersGridData: any;
  formData = {};
  selectedCols: any;
  cols: any;
  businessName: any;
  showForm = false;
  showView = false;
  selectedRow = {};
  selectedCustomer: any;
  displayCustomerPopUp = false;
  newCustomer = {
    customer_id: 0,
    customer_name: '',
    address: '',
    city: '',
    state: '',
    zip_code: '',
    created_by: '',
    customer_region: '',
    businessunit_id: 1,
    distributor_id:-1,
  };
  distributorData: any;
  regionData = [
    {
      region_id: 1,
      region_name: 'North America'
    }
  ];
  selectedRegion: any;
  selectedDistributor: any;
  popUpHeading: string = '';

  constructor(private _http: HttpClient,private router: Router, private spinner: NgxSpinnerService, private toastr: ToastrService, private _service: CupsService, private confirmationService: ConfirmationService) { }


  ngOnInit() {
    this.spinner.show();
    this._service.getDistributorsMC(1).subscribe((response: any) => {
      this.distributorData = response.response;
      this.spinner.hide();
    },
      (error) => {
        console.log(error);
      });
    this.cols = [
      {
        "header_id": 1,
        "field": "customer_distributer_Id",
        "header": "Customer Distributor",
        "is_show": false,
        "is_editable": false,
        "serial_no": 1
      },
      {
        "header_id": 2,
        "field": "customer_name",
        "header": "Customer Name",
        "is_show": true,
        "is_editable": false,
        "serial_no": 2
      },
      {
        "header_id": 3,
        "field": "distributor_name",
        "header": "Distributor Name",
        "is_show": true,
        "is_editable": false,
        "serial_no": 3
      },
      {
        "header_id": 4,
        "field": "businessunit_name",
        "header": "Bussiness Unit",
        "is_show": true,
        "is_editable": false,
        "serial_no": 4
      },
      {
        "header_id": 5,
        "field": "customer_id",
        "header": "Customer Id",
        "is_show": false,
        "is_editable": false,
        "serial_no": 5
      },
      {
        "header_id": 6,
        "field": "distributor_id",
        "header": "Distributor Id",
        "is_show": false,
        "is_editable": false,
        "serial_no": 6
      },
    ]
    this.getDistributorCustomerMappingDetail();
  }

  getDistributorCustomerMappingDetail() {
    this.spinner.show();
    this._service.getDistributorCustomerMappingDetail(1).subscribe((response: any) => {
      this.manageCustomersGridData = response.response;
      this.spinner.hide();
    });
  }

  addNewCustomer() {
    this.selectedDistributor = null;
    this.selectedRegion = null;
    this.popUpHeading = 'Add Customer';
    this.newCustomer = {
      customer_id: 0,
      customer_name: '',
      address: '',
      city: '',
      state: '',
      zip_code: '',
      created_by: '',
      customer_region: '',
      businessunit_id: 1,
      distributor_id: -1,
    };
    this.displayCustomerPopUp = true;
  }

  checkValidDistributor() {
    if (!this.selectedDistributor) {
      this.toastr.error("Distributor required", "Error!");
      return false;
    } else {
      return true;
    }
  }

  checkValidCustomerName() {
    if (this.newCustomer.customer_name != "") {
      if (this.newCustomer.customer_name.length > 50) {
        this.toastr.error("Customer Name should be of 50 characters", "Error!");
        return false;
      }
      return true;
    } else {
      this.toastr.error("Customer Name required", "Error!");
      return false;
    }
  }

  checkValidCustomerAddress() {
    if (this.newCustomer.address != "") {
      if (this.newCustomer.address.length > 100) {
        this.toastr.error("Customer Address should be of 100 characters", "Error!");
        return false;
      }
      return true;
    } else {
      this.toastr.error("Customer Address required", "Error!");
      return false;
    }
  }

  checkValidCustomerCity() {
    if (this.newCustomer.city != "") {
      if (this.newCustomer.city.length > 50) {
        this.toastr.error("Customer city should be of 50 characters", "Error!");
        return false;
      }
      return true;
    } else {
      this.toastr.error("Customer City required", "Error!");
      return false;
    }
  }

  checkValidCustomerState() {
    if (this.newCustomer.state != "") {
      if (this.newCustomer.state.length > 50) {
        this.toastr.error("Customer state should be of 50 characters", "Error!");
        return false;
      }
      return true;
    } else {
      this.toastr.error("Customer State required", "Error!");
      return false;
    }
  }

  checkValidCustomerZipcode() {
    if (this.newCustomer.zip_code != "") {
      if (this.newCustomer.zip_code.length > 25) {
        this.toastr.error("Customer Zipcode should be of 25 characters", "Error!");
        return false;
      }
      return true;
    } else {
      this.toastr.error("Customer Zipcode required", "Error!");
      return false;
    }
  }

  checkValidCustomerRegion() {
    if (this.newCustomer.customer_region != "") {
      return true;
    } else {
      this.toastr.error("Customer Region required", "Error!");
      return false;
    }
  }

  checkCustomerValidation() {
    let validCustomerRegion = this.checkValidCustomerRegion();
    let validCustomerZipcode = this.checkValidCustomerZipcode();
    let validCustomerState = this.checkValidCustomerState();
    let validCustomerCity = this.checkValidCustomerCity();
    let validCustomerAddress = this.checkValidCustomerAddress();
    let validCustomerName = this.checkValidCustomerName();
    let validDistributor = this.checkValidDistributor();
    return validCustomerName && validCustomerCity && validCustomerState &&
      validCustomerZipcode && validCustomerRegion && validCustomerAddress && validDistributor;
  }

  onSubmit() {
    
    this.newCustomer.created_by = sessionStorage.getItem('userid');
    this.newCustomer.businessunit_id = 1;
    if (this.selectedDistributor) {
      this.newCustomer.distributor_id = this.selectedDistributor.distributor_id;
    }
    if (this.selectedRegion) {
      this.newCustomer.customer_region = this.selectedRegion.region_id;
    }
    if (this.checkCustomerValidation()) {
      if (this.popUpHeading === 'Add Customer') {
        this.addCustomerData();
      } else {
        this.updateCustomerData();
      }
    }
  }

  cancelCustomerPopUp() {
    this.displayCustomerPopUp = false;
  }

  onSelectRow(rowObject) {
    let { rowData, type } = rowObject;
    this.selectedRow = JSON.parse(JSON.stringify(rowData));
    console.log(rowData);
    if (type == 'edit') {
      this.popUpHeading = 'Edit Customer';
      this.displayCustomerPopUp = true;
      this._service.getCustomerDetail(rowData.customer_id).subscribe(_response => {
        const typedResponse = _response as CustomerResponse;
        this.distributorData.forEach(dd => {
          if (dd.distributor_id == rowData.distributor_id) {
            this.selectedDistributor = dd;
          }
        });
        this.newCustomer.customer_id = rowData.customer_id;
        this.newCustomer.customer_name = typedResponse.response.customer_name;
        this.newCustomer.address = typedResponse.response.address;
        this.newCustomer.city = typedResponse.response.city;
        this.newCustomer.state = typedResponse.response.state;
        this.newCustomer.zip_code = typedResponse.response.zip_code;
        this.selectedRegion = this.regionData[0];
        this.regionData.forEach(rd => {
          if (rd.region_id === typedResponse.response.customer_region) {
            this.selectedRegion = rd;
          }
        });
      });
     
    } else {
      this.confirmationService.confirm({
        message: 'Are you sure to delete?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.deleteCustomerData(rowData);
        },
        reject: () => {
        }
      });
    }
  }

  addCustomerData() {
    this.spinner.show();
    this._service.addCustomer(this.newCustomer).subscribe(response => {
      this.spinner.hide();
      if (!response['isError']) {
        this._service.displayToastr(response);
        this.getDistributorCustomerMappingDetail();
      } else {
        this._service.displayToastr(response);
      }
      this.cancelCustomerPopUp();
    });
  }

  updateCustomerData() {
    console.log(this.selectedRow);
    const typedRowData = this.selectedRow as RowData;
    this.newCustomer.distributor_id = this.selectedDistributor.distributor_id;
    this.newCustomer.customer_region = this.selectedRegion.region_id;
    this.spinner.show
    this._service.editCustomer(typedRowData.customer_distributer_Id, this.newCustomer).subscribe(response => {
      this.spinner.hide();
      if (!response['isError']) {
        this._service.displayToastr(response);
        this.getDistributorCustomerMappingDetail();
      } else {
        this._service.displayToastr(response);
      }
      this.cancelCustomerPopUp();
    })
  }

  deleteCustomerData(rowData) {
    this.spinner.show();
    this._service.deleteCustomer(rowData.customer_distributer_Id).subscribe(response => {
      this.spinner.hide();
      if (!response['isError']) {
        this._service.displayToastr(response);
        this.getDistributorCustomerMappingDetail();
      } else {
        this._service.displayToastr(response);
      }
    })
  }

  sortColumns() {
    this.selectedCols = this.selectedCols.sort((a, b) => {
      return a.serial_no - b.serial_no;
    })
  }
}
